var LayoutFlexDirection;
(function (LayoutFlexDirection) {
    LayoutFlexDirection["COLUMN"] = "column";
    LayoutFlexDirection["COLUMN_REVERSE"] = "column-reverse";
    LayoutFlexDirection["INHERIT"] = "inherit";
    LayoutFlexDirection["INITIAL"] = "initial";
    LayoutFlexDirection["NONE"] = "";
    LayoutFlexDirection["ROW"] = "row";
    LayoutFlexDirection["ROW_REVERSE"] = "row-reverse";
    LayoutFlexDirection["UNSET"] = "unset";
})(LayoutFlexDirection || (LayoutFlexDirection = {}));
export default LayoutFlexDirection;
//# sourceMappingURL=layout-flex-direction.js.map